import { useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";
import { ReleaseCard, EmptyState, PageTitle } from "@/components/site/ReleaseCard";

export default function Releases() {
  const [releases, setReleases] = useState([]);
  const [filter, setFilter] = useState("Tutte");
  useEffect(() => { api.get("/releases").then((r) => setReleases(r.data)).catch(() => {}); }, []);
  const types = useMemo(() => ["Tutte", ...new Set(releases.map((r) => r.release_type).filter(Boolean))], [releases]);
  const shown = filter === "Tutte" ? releases : releases.filter((r) => r.release_type === filter);

  return (
    <div data-testid="releases-page">
      <PageTitle over="Catalogo" title="Uscite" sub="Tutti i dischi, singoli ed EP pubblicati da The Groove Anomaly records." />
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        {types.length > 2 && (
          <div className="flex flex-wrap gap-2 mb-10">
            {types.map((t) => (
              <button key={t} onClick={() => setFilter(t)} data-testid={`releases-filter-${t.toLowerCase()}`}
                className={`rounded-full px-4 py-2 font-mono-tga text-xs uppercase tracking-[0.15em] border transition-colors ${filter === t ? "bg-emerald-500 text-black border-emerald-500" : "border-white/15 text-zinc-300 hover:border-white/40"}`}>{t}</button>
            ))}
          </div>
        )}
        {shown.length ? (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5 sm:gap-8" data-testid="releases-grid">
            {shown.map((r, i) => <ReleaseCard key={r.id} release={r} i={i} />)}
          </div>
        ) : (
          <EmptyState testid="releases-empty" title="Nessuna uscita ancora" text="Torna presto: nuova musica in arrivo." />
        )}
      </div>
    </div>
  );
}
